import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { Loader } from '@fremtind/jkl-loader-react';

var BaseButton = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("button", _extends({}, props, {
    ref: ref
  }));
});
BaseButton.displayName = "BaseButton";

var _excluded = ["children", "className", "forceCompact", "inverted", "onClick", "onTouchStart", "loader"];

var makeButtonComponent = function makeButtonComponent(buttonType) {
  var button = /*#__PURE__*/forwardRef(function (_ref, ref) {
    var children = _ref.children,
        _ref$className = _ref.className,
        className = _ref$className === void 0 ? "" : _ref$className,
        forceCompact = _ref.forceCompact,
        inverted = _ref.inverted,
        onClick = _ref.onClick,
        onTouchStart = _ref.onTouchStart,
        loader = _ref.loader,
        rest = _objectWithoutProperties(_ref, _excluded);

    var componentClassName = classNames("jkl-button", "jkl-button--" + buttonType, {
      "jkl-button--compact": forceCompact,
      "jkl-button--inverted": inverted
    });

    var handleTouch = function handleTouch(event) {
      onTouchStart && onTouchStart(event);
      var target = event.target;

      if (target && event.targetTouches.length) {
        var Xcoord = event.targetTouches[0].clientX - target.getBoundingClientRect().x;
        var Ycoord = event.targetTouches[0].clientY - target.getBoundingClientRect().y;
        target.style.setProperty("--jkl-touch-xcoord", Xcoord.toPrecision(4) + "px");
        target.style.setProperty("--jkl-touch-ycoord", Ycoord.toPrecision(4) + "px");
        target.classList.add("jkl-button--pressed");
        setTimeout(function () {
          return target.classList.remove("jkl-button--pressed");
        }, 400);
      }
    };

    if (!loader) {
      return /*#__PURE__*/React.createElement(BaseButton, _extends({
        className: classNames(componentClassName, className),
        onClick: onClick,
        onTouchStart: handleTouch
      }, rest, {
        ref: ref
      }), children);
    }

    return /*#__PURE__*/React.createElement("div", {
      className: classNames("jkl-button-wrapper", className, {
        "jkl-button-wrapper--compact": forceCompact
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames("jkl-button-wrapper__slider", {
        "jkl-button-wrapper__slider--show-loader": !!loader.showLoader
      })
    }, /*#__PURE__*/React.createElement(BaseButton, _extends({
      className: componentClassName,
      onClick: onClick,
      onTouchStart: handleTouch,
      disabled: loader === null || loader === void 0 ? void 0 : loader.showLoader
    }, rest, {
      ref: ref
    }), children), (loader === null || loader === void 0 ? void 0 : loader.showLoader) && /*#__PURE__*/React.createElement("div", {
      className: "jkl-button-wrapper__loader jkl-layout-spacing--small-top"
    }, /*#__PURE__*/React.createElement(Loader, {
      textDescription: loader.textDescription,
      negative: inverted,
      "aria-hidden": !!loader.showLoader,
      inline: true
    }))));
  });
  return button;
};

var PrimaryButton = makeButtonComponent("primary");
var SecondaryButton = makeButtonComponent("secondary");
var TertiaryButton = makeButtonComponent("tertiary");

export { PrimaryButton, SecondaryButton, TertiaryButton };
